// FIFA 3-letter codes → ISO 3166-1 alpha-2 (used by flagcdn.com)
export const FIFA_TO_ISO2: Record<string, string> = {
  ARG: 'ar', BRA: 'br', FRA: 'fr', GER: 'de', ESP: 'es',
  ENG: 'gb-eng', POR: 'pt', NED: 'nl', ITA: 'it', BEL: 'be',
  CRO: 'hr', URU: 'uy', MAR: 'ma', SEN: 'sn', JPN: 'jp',
  KOR: 'kr', USA: 'us', MEX: 'mx', CAN: 'ca', POL: 'pl',
  DEN: 'dk', SUI: 'ch', AUS: 'au', SRB: 'rs', COL: 'co',
  KSA: 'sa', ECU: 'ec', CRC: 'cr', TUN: 'tn', CMR: 'cm',
  GHA: 'gh', IRN: 'ir',
  NOR: 'no', AUT: 'at', TUR: 'tr', UKR: 'ua', EGY: 'eg',
  NGA: 'ng', ALG: 'dz', CIV: 'ci', JAM: 'jm', PAN: 'pa',
  HAI: 'ht', PAR: 'py', NZL: 'nz', UAE: 'ae', IRQ: 'iq',
  UZB: 'uz',
  RSA: 'za', CZE: 'cz', BIH: 'ba', QAT: 'qa', SCO: 'gb-sct',
  CUW: 'cw', SWE: 'se', CPV: 'cv', JOR: 'jo', COD: 'cd',
};

export const TEAM_NAME_PL: Record<string, string> = {
  ARG: 'Argentyna', BRA: 'Brazylia', FRA: 'Francja', GER: 'Niemcy', ESP: 'Hiszpania',
  ENG: 'Anglia', POR: 'Portugalia', NED: 'Holandia', ITA: 'Włochy', BEL: 'Belgia',
  CRO: 'Chorwacja', URU: 'Urugwaj', MAR: 'Maroko', SEN: 'Senegal', JPN: 'Japonia',
  KOR: 'Korea Pd.', USA: 'USA', MEX: 'Meksyk', CAN: 'Kanada', POL: 'Polska',
  DEN: 'Dania', SUI: 'Szwajcaria', AUS: 'Australia', SRB: 'Serbia', COL: 'Kolumbia',
  ECU: 'Ekwador', CRC: 'Kostaryka', TUN: 'Tunezja', CMR: 'Kamerun', GHA: 'Ghana',
  IRN: 'Iran', KSA: 'Arabia S.',
  NOR: 'Norwegia', AUT: 'Austria', TUR: 'Turcja', UKR: 'Ukraina', EGY: 'Egipt',
  NGA: 'Nigeria', ALG: 'Algieria', CIV: 'WKS', JAM: 'Jamajka', PAN: 'Panama',
  HAI: 'Haiti', PAR: 'Paragwaj', NZL: 'Nowa Zelandia', UAE: 'ZEA', IRQ: 'Irak',
  UZB: 'Uzbekistan',
  RSA: 'RPA', CZE: 'Czechy', BIH: 'Bośnia', QAT: 'Katar', SCO: 'Szkocja',
  CUW: 'Curaçao', SWE: 'Szwecja', CPV: 'Cabo Verde', JOR: 'Jordania', COD: 'DR Konga',
};

export function teamNamePl(code: string): string {
  return TEAM_NAME_PL[code] ?? code;
}
